var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"page info"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"info-section",domProps:{"innerHTML":_vm._s(_vm.$t('PAGE_ERROR_BOOKLETS_MESSAGE'))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }